//测试
// export const WSPREVIEW = 'ws://'+location.host+'/socket';
// export const HTTPPREVIEW = 'http://'+location.host+'/cms';
// //线上
export const WSPREVIEW = 'wss://'+location.host+'/socket';
export const HTTPPREVIEW = 'https://'+location.host+'/cms';

